<nav mat-tab-nav-bar class="card stacked elevated">
  <a
    mat-tab-link
    *ngFor="let t of tabs"
    (click)="activeTab$.next(t.value)"
    [active]="(activeTab$ | async) == t.value"
  >
    {{ 'manual_correction.' + t.label | translate }}
  </a>
</nav>

<div *ngIf="displayedAnswers$ | async as answers; else loading">
  <ng-container *ngIf="answers?.length">
    <table mat-table [dataSource]="dataSource">
      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'manual_correction.date' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.created_at | amDateFormat: 'll' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="score">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'manual_correction.result' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.feedback_score">
            {{ element?.feedback_score }} / {{ element?.question?.value }}
          </ng-container>

          <ng-container *ngIf="!element.feedback_score">
            {{ 'manual_correction.still_not_corrected' | translate }}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="level">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'manual_correction.level' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.question?.support?.exam?.level }}
        </td>
      </ng-container>

      <ng-container matColumnDef="feedback_at">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'manual_correction.correction_date' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.feedback_at | amDateFormat: 'll' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="is_mock">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'manual_correction.mock_exam' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.result_id">
            {{ 'manual_correction.yes' | translate }}
          </ng-container>

          <ng-container *ngIf="!element.result_id">
            {{ 'manual_correction.no' | translate }}
          </ng-container>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="student">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'manual_correction.learner' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element?.user?.first_name">
            {{ element?.user?.first_name }} {{ element?.user?.last_name }}
          </ng-container>

          <ng-container *ngIf="!element?.user?.first_name">
            {{ element?.email }}
          </ng-container>
        </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="part">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'manual_correction.type' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{
            getPart(
              element.question.support.part,
              element?.question?.support?.exam?.level
            )?.subCategory
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'manual_correction.actions' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            aria-label="Actions on the user"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              *ngFor="let action of actions; trackBy: trackByMethod"
              mat-menu-item
              (click)="action.click(element)"
            >
              <mat-icon>{{ action.icon }}</mat-icon>
              <span>{{ action.text }}</span>
            </button>

            <button
              type="button"
              mat-menu-item
              (click)="
                openAddOrgDialog(correctionForm, footerTemplate, element)
              "
            >
              <ng-container *ngIf="role === 'teacher'">
                <mat-icon>edit</mat-icon>
                <span>{{ 'manual_correction.to_correct2' | translate }}</span>
              </ng-container>

              <ng-container *ngIf="role === 'user'">
                <mat-icon>visibility</mat-icon>
                <span>{{ 'manual_correction.see_exercise' | translate }}</span>
              </ng-container>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[20, 50, 100]"
      showFirstLastButtons
      aria-label="Select page"
    >
    </mat-paginator>
  </ng-container>

  <div *ngIf="!answers.length" class="mat-padding mat-card mat-elevation-z0">
    <div class="text-center ">
      <p>
        {{ 'manual_correction.empty' | translate }}
      </p>
      <br /><br />
      <img width="300" src="/assets/delf/img/not_found.svg" />
    </div>
  </div>
</div>

<ng-template #loading>
  <app-loader></app-loader>
</ng-template>

<ng-template #correctionForm>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="32px">
    <div fxFlex>
      <div fxLayout="column" fxLayoutGap="16px">
        <div>
          <h3>
            {{ 'manual_correction.exercise' | translate }}
          </h3>
          <div>
            <polylearn-support-view
              [support]="support$ | async"
            ></polylearn-support-view>
          </div>
        </div>

        <div>
          <h3>
            <ng-container *ngIf="role === 'user'">
              {{ 'manual_correction.my_answer' | translate }}
            </ng-container>

            <ng-container *ngIf="role === 'teacher'">
              {{ 'manual_correction.user_answer' | translate }}
            </ng-container>
          </h3>
          <div>
            <ng-container
              *ngIf="selectedAnswer?.extra_value?.startsWith('https')"
            >
              <audio controls [src]="selectedAnswer.extra_value">
                Your browser does not support the
                <code>audio</code> element.
              </audio>
            </ng-container>

            <div
              *ngIf="!selectedAnswer?.extra_value?.startsWith('https')"
              class="custom-input"
              [innerHTML]="
                selectedAnswer?.extra_value?.replaceAll('\n', '<br>')
              "
            ></div>
          </div>
        </div>

        <div>
          <h3>
            {{ 'manual_correction.suggested_correction' | translate }}
          </h3>

          <div
            class="show-warning md-padding"
            [innerHTML]="
              (support$ | async)?.questions[0]?.correction?.replaceAll(
                '\n',
                '<br>'
              )
            "
          ></div>
        </div>
      </div>
    </div>

    <div fxFlex>
      <h3>
        {{ 'manual_correction.teacher_correction' | translate }}
      </h3>

      <div class="show-warning md-padding">
        <div *ngIf="role === 'user'; else correctionForm">
          <ng-container *ngIf="editAnswersForm?.value?.feedback">
            <div>
              <b
                >{{ 'manual_correction.score' | translate }}
                {{ editAnswersForm?.value?.feedback_score }} /
                {{ selectedAnswer?.question?.value }}<br
              /></b>
              <br />
            </div>
            <div
              [innerHTML]="
                editAnswersForm?.value?.feedback?.replaceAll('\n', '<br>')
              "
            ></div>
          </ng-container>
          <div *ngIf="!editAnswersForm?.value?.feedback">
            {{ 'manual_correction.not_corrected_3' | translate }}
          </div>
        </div>
        <ng-template #correctionForm>
          <form
            id="editAnswersForm"
            *ngIf="editAnswersForm"
            [formGroup]="editAnswersForm"
          >
            <div fxLayout="column" fxLayoutGap="16px">
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ 'manual_correction.feedback' | translate }}
                </mat-label>
                <textarea
                  rows="10"
                  formControlName="feedback"
                  matInput
                  #input
                  placeholder="Correction"
                ></textarea>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>
                  {{ 'manual_correction.score_2' | translate }}
                </mat-label>
                <input
                  min="0"
                  [max]="selectedAnswer?.question?.value"
                  formControlName="feedback_score"
                  matInput
                  #input
                  type="number"
                  [placeholder]="'0 - ' + selectedAnswer?.question?.value"
                />
              </mat-form-field>
            </div>
          </form>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div fxLayout="row" fxLayoutGap="16px" style="width: 100%;">
    <span class="flex"> </span>

    <button
      class="md-outline md-button md-primary"
      type="button"
      mat-button
      mat-dialog-close
    >
      {{ 'manual_correction.close' | translate }}
    </button>

    <button
      *ngIf="role === 'teacher'"
      color="primary"
      [disabled]="editAnswersForm.invalid"
      mat-raised-button
      type="button"
      class="md-raised md-button"
      mat-button
      [mat-dialog-close]="editAnswersForm.value"
    >
      {{ 'manual_correction.validate' | translate }}
    </button>
  </div>
</ng-template>
